/**
 * aminos-ugc-video-grid.js
 *
 * Custom play/pause toggle for video tiles.
 * - Click the bottom-right button → toggle the video's play/pause state
 * - Listen to video's own play/pause events to keep .is-playing in sync
 *   (so the toggle icon flips correctly even if playback is triggered
 *    by other means, e.g. autoplay-on-scroll added later)
 *
 * Event-delegated at document level so it works for sections re-rendered
 * via the Shopify Section Rendering API. Capture phase used for play/pause
 * since those events don't bubble.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.aminos-ugc-video-grid__toggle');
    if (!btn) return;
    var tile = btn.closest('.aminos-ugc-video-grid__video');
    if (!tile) return;
    var video = tile.querySelector('video.aminos-ugc-video-grid__player');
    if (!video) return;
    e.preventDefault();
    if (video.paused) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          // Autoplay can be blocked; nothing to do — user will retry.
        });
      }
    } else {
      video.pause();
    }
  });

  document.addEventListener(
    'play',
    function (e) {
      var video = e.target;
      if (!video.classList || !video.classList.contains('aminos-ugc-video-grid__player')) return;
      var tile = video.closest('.aminos-ugc-video-grid__video');
      var btn = tile && tile.querySelector('.aminos-ugc-video-grid__toggle');
      if (tile) tile.classList.add('is-playing');
      if (btn) btn.setAttribute('aria-label', 'Pause video');

      // Only one video plays at a time within a grid — pause the others.
      var scope = video.closest('.aminos-ugc-video-grid') || document;
      scope.querySelectorAll('video.aminos-ugc-video-grid__player').forEach(function (other) {
        if (other !== video && !other.paused) other.pause();
      });
    },
    true
  );

  document.addEventListener(
    'pause',
    function (e) {
      var video = e.target;
      if (!video.classList || !video.classList.contains('aminos-ugc-video-grid__player')) return;
      var tile = video.closest('.aminos-ugc-video-grid__video');
      var btn = tile && tile.querySelector('.aminos-ugc-video-grid__toggle');
      if (tile) tile.classList.remove('is-playing');
      if (btn) btn.setAttribute('aria-label', 'Play video');
    },
    true
  );
})();
